export default __webpack_public_path__ + "static/media/storefront_black_48dp.b94dc624.svg";